import { Task, TaskType } from '@graphql/generated'

export const getTaskById = (tasks: Task[], id: string): Task | false => tasks?.find(task => task.taskId === id) || false

export const getTaskByType = (tasks: Task[] | null, type: TaskType): Task | false =>
  tasks?.find(task => task.type === type) || false
